export default "__VITE_ASSET__BBMkTybF__"